module.exports = __webpack_public_path__ + "components/patterns/cardVisit/card-visit.tpl.php";